import {
    createStore, applyMiddleware, compose,
  } from 'redux';
  import createSagaMiddleware from 'redux-saga';
  import rootReducer from './Reducer/reducer';
  import {persistStore } from 'redux-persist';
  import {  watchAuthentication, watchVTO, watchHomePage, watchOvertime } from './Sagas/rootSaga';

  let lastSerializedState = '';

  const getPersistableState = (state) => {
    if (!state || !state.OvertimeReducer) return state;

    // timerNowMs changes every second while callback holds are active and
    // should not trigger full localStorage rewrites.
    const { timerNowMs, ...overtimePersistable } = state.OvertimeReducer;

    return {
      ...state,
      OvertimeReducer: overtimePersistable,
    };
  };


  function saveToLocalStorage(state) {
    try {
      const serializedState = JSON.stringify(getPersistableState(state))
      if (serializedState === lastSerializedState) return;

      localStorage.setItem('state', serializedState)
      lastSerializedState = serializedState;
    } catch (err) {
      console.log(err)
    }
  }
  
  function loadFromLocalStorage() {
    try {
      const serializedState = localStorage.getItem('state');
      if (serializedState === null) return undefined;
      lastSerializedState = serializedState;
      return JSON.parse(serializedState)
    } catch (err) {
      console.log(err)
      return undefined;
    }
  }
  
  const persistedState = loadFromLocalStorage();
  const sagaMiddleware = createSagaMiddleware();
  // const persistConfig = {
  //   key:'root', storage
  // }
  // const persistedReducer = persistReducer(persistConfig, rootReducer);
  const composeEnhancers = process.env.NODE_ENV === 'production' ? compose : (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose);
  // eslint-disable-next-line import/no-anonymous-default-export
  const configureStore = () => {
    const store = createStore(rootReducer,persistedState, composeEnhancers(applyMiddleware(sagaMiddleware)));
    sagaMiddleware.run(watchAuthentication);
    sagaMiddleware.run(watchVTO);
    sagaMiddleware.run(watchHomePage);
    sagaMiddleware.run(watchOvertime);
    store.subscribe(() => saveToLocalStorage(store.getState()))
    let persistor = persistStore(store)
    return {store, persistor};
  
  }
  export default configureStore;
  